// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__EEd4c","title":"style_title__oBaHX","bottom":"style_bottom__vTqVM","button":"style_button__CTU-T"};